var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGoogleButtonIcon = function SvgGoogleButtonIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2184_14360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7875 10.225C19.7875 9.56671 19.7292 8.94171 19.6292 8.33337H10.2125V12.0917H15.6042C15.3625 13.325 14.6542 14.3667 13.6042 15.075V17.575H16.8209C18.7042 15.8334 19.7875 13.2667 19.7875 10.225Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2125 20C12.9125 20 15.1709 19.1 16.8209 17.575L13.6042 15.075C12.7042 15.675 11.5625 16.0417 10.2125 16.0417C7.6042 16.0417 5.39587 14.2833 4.6042 11.9083H1.28754V14.4833C2.9292 17.75 6.3042 20 10.2125 20Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60419 11.9084C4.39586 11.3084 4.28752 10.6667 4.28752 10.0001C4.28752 9.33339 4.40419 8.69172 4.60419 8.09172V5.51672H1.28752C0.60419 6.86672 0.212524 8.38339 0.212524 10.0001C0.212524 11.6167 0.60419 13.1334 1.28752 14.4834L4.60419 11.9084Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2125 3.95833C11.6875 3.95833 13.0042 4.46667 14.0459 5.45834L16.8959 2.60833C15.1709 0.991668 12.9125 0 10.2125 0C6.3042 0 2.9292 2.25 1.28754 5.51667L4.6042 8.09167C5.39587 5.71667 7.6042 3.95833 10.2125 3.95833Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2184_14360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleButtonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "google-button-icon.90517c496cdd28f9ad1a7a3d3c656486.svg";